import { defaultIllustrations, agodaIllustrations } from '@ads/assets';
import { getAssetDataFromTheme } from '../VisualAssets/utility/getAssetDataFromTheme/getAssetDataFromTheme.js';

var getHash = function getHash(theme, id) {
  var storage = {
    default: defaultIllustrations,
    agoda: agodaIllustrations
  };
  return getAssetDataFromTheme(id, storage, theme);
};

export { getHash };
//# sourceMappingURL=Illustration.mappers.js.map
